/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AutomateTaskHistoryService {

  constructor(private http: HttpClient) { }

  getHistory(emailDetailId: string) {
    return this.http
      .get(
        `/api/v1/automate_task_history/ed/${emailDetailId}`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/automate-task-history.service.ts